import React, { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { LoginContext } from "../components/context/LoginContext"

const LOGIN_MAIN_PAGE = "/my"

export default () => {
  const navigate = useNavigate()
  const { isLogined } = useContext(LoginContext)

  useEffect(() => {
    // 외부 임베드 진입: ?code=<RCODE>&nid=<학번>
    // nid 는 이후 리다이렉트(/login/:code → /profile)에서 유실되지 않도록 sessionStorage 에 보관,
    // code 가 있으면 코드 입력 단계를 건너뛰고 바로 진입 흐름으로 보낸다.
    const params = new URLSearchParams(window.location.search)
    const nid = params.get("nid")
    const code = params.get("code")
    if (nid) sessionStorage.setItem("entry_nid", nid)

    if (isLogined()) {
      navigate(LOGIN_MAIN_PAGE, { replace: true })
    } else if (code) {
      navigate(`/login/${code}`, { replace: true })
    } else {
      navigate("/login", { replace: true })
    }
  }, [])

  return null
}
